import React from 'react';
import { CssBaseline } from '@material-ui/core';

import Routes from './routes';

const App = () => (
  <React.Fragment>
    <CssBaseline />
    <Routes />
  </React.Fragment>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js